export default __webpack_public_path__ + "static/media/na_en.1827e5df.png";